import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { sendMail } from "../../../helpers/email";
import { schema } from "../../../helpers/schema";
import { yupResolver } from "@hookform/resolvers/yup";
import Input from "../../../components/Input";

const ContactInfoSectionUI = styled.div`
  width: 50%;
  height: 100%;
  /* background-color: rgba(0, 0, 0, 95); */
  background-color: var(--black);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 992px) {
    width: 60%;
    height: unset;
  }
  @media screen and (max-width: 675px) {
    width: 100%;
    padding: 50px 0px;
  }
`;

const FormTitle = styled.h1`
  font-size: 2.5rem;
  color: var(--white);
  margin-bottom: 1rem;
  font-family: var(--raleway);
`;

const Form = styled.form`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  @media (max-width: 1300px) {
    width: 60%;
  }

  @media (max-width: 1100px) {
    width: 65%;
  }

  @media (max-width: 992px) {
    width: 75%;
  }
  @media (max-width: 675px) {
    width: 70%;
  }
  @media (max-width: 475px) {
    width: 75%;
  }
`;

const FormName = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  color: var(--white);
  @media (max-width: 475px) {
    flex-direction: column;
    align-items: center;
  }
`;

const FormInputSubmit = styled.input`
  width: 30%;
  background-color: var(--white);
  color: var(--black);
  height: 30px;
  border: 1px solid var(--black);
`;

const FormSuccess = styled.p`
  color: green;
  font-size: 1rem;
  font-family: "Manrope-regular";
`;

const FormError = styled.p`
  color: red;
  font-size: 1rem;
  font-family: "Manrope-regular";
`;

const ContactInfo = () => {
  const [isValidForm, setIsValidForm] = useState(null);

  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: yupResolver(schema),
  });
  const onSubmit = (data) => {
    const { name, surname, email, msg, subject } = data;
    console.log(data);
    let templateParams = {
      name: name,
      surname: surname,
      email: email,
      subject: subject,
      msg: msg,
    };
    sendMail(templateParams, setIsValidForm, reset);
  };
  useEffect(() => {
    let interval;
    interval = setTimeout(() => {
      setIsValidForm(null);
    }, 2000);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValidForm]);
  return (
    <>
      <ContactInfoSectionUI data-aos="fade-left" data-aos-delay="300">
        <FormTitle>Contactanos</FormTitle>
        <Form
          autocomplete="off"
          noValidate
          onSubmit={handleSubmit(onSubmit)}
          name="contact"
        >
          <FormName>
            <Input
              id="name"
              name="name"
              width="50%"
              type="text"
              placeholder="Nombre"
              label="Nombre"
              control={control}
              error={errors.name}
            />
            <Input
              id="surname"
              name="surname"
              width="50%"
              type="text"
              placeholder="Apellido"
              label="Apellido:"
              control={control}
              error={errors.surname}
            />
          </FormName>
          <Input
            id="email"
            name="email"
            width="100%"
            type="email"
            placeholder="Email"
            label="Email:"
            control={control}
            error={errors.email}
          />
          <Input
            id="subject"
            name="subject"
            width="100%"
            type="text"
            placeholder="Asunto"
            label="Asunto:"
            control={control}
            error={errors.subject}
          />
          <Input
            textArea
            id="msg"
            name="msg"
            width="100%"
            type="text"
            placeholder="Mensaje"
            label="Mensaje:"
            control={control}
            error={errors.msg}
          />
          <FormInputSubmit type="submit" value="Enviar" />
          {isValidForm ? (
            <FormSuccess>El mensaje se ha enviado correctamente</FormSuccess>
          ) : isValidForm === false ? (
            <FormError>Error de servidor, intente mas tarde.</FormError>
          ) : null}
        </Form>
      </ContactInfoSectionUI>
    </>
  );
};

export default ContactInfo;
